<template>
  <div class="bankManage">
    <!--  -->
    <div class="common-box border-t0 margin-l6">
      <el-row class="row-one">
        <span class="row-one-title">银行卡管理</span>
      </el-row>
      <!--  -->
      <div class="bankManage-caption">
        <span>我的银行卡</span>
        <span>共 <i class="rColor">{{bankLists.length}}</i> 张银行卡</span>
        <span>目前线上仅支持添加银行卡、删卡操作</span>
        <el-button type="cancel" class="margin-l20" @click="$router.push({name:'cardReplaceRecord'})">换卡记录</el-button>
        <el-button v-if="bankLists.length>0" type="normal1" @click="$router.push({name:'bankCardAdd'})">+继续添加银行卡</el-button>
      </div>
      <!-- 银行卡 -->
      <div v-if="bankLists.length>0">
        <!--  -->
        <div class="bankManage-bankCard">
          <div :class="['card',{'activee':item.active}]" v-for="(item,i) in bankLists" :key="i" @click="bankImgClick(item, i)">
            <img :src="require('../../../assets/images/bank/' + $store.state.bankImgObj[item.channelid])" alt="">
            <div class="num">{{' xxxx xxxx xxxx ' + item.depositaccount.slice(item.depositaccount.length - 4)}}</div>
            <div class="tips" v-if="item.hfsignresult == '0'">可迁移新支付渠道，享更大额度</div>
          </div>
        </div>
        <!--  -->
        <ul class="bankManage-cardDetail">
          <!-- 0正常 1销户 2挂失 3销户中 4复合锁定 -->
          <!-- <li>支付状态：<span>{{bankCardStatus}}</span> </li> -->
          <li>支付渠道：<span>{{paycenterName}}支付</span><span class="margin-l20 operate" @click="dialogVisableChange = true">更换</span></li>
          <li>支付额度：
            <span>{{'单笔限额'+ SingleDealLimit+'/单日限额' + SingleDayLimit}}</span>
          </li>
          <li>开通时间：<span>{{$commonJs.getDateStrHg(bankCardTime)}}</span></li>
          <li>默认银行卡： <el-radio class="radio-single-one" v-model="defaultRadio" :label="true" @change="defaultCard">是</el-radio>
          </li>
        </ul>
        <ul class="bankManage-cardDetail" style="text-align: right;font-weight: normal;">
          <li><span class="operate margin-l20" @click="hfVerification">新增支付渠道</span></li>
          <li></li>
          <li></li>
          <li>
            <span class="operate" @click="dialogVisable = true">删除此银行卡</span>
            
            <!-- <span v-if="hfFlag" class="operate margin-l20" @click="hfVerification">迁移新支付渠道</span> -->
          </li>
        </ul>
      </div>
      <div v-else class="cardBox">
        <img src="../../../assets/images/20200908_bank.png" alt=""><br />
        <el-button type="normal" class="margin-t20" @click="$router.push({name:'bankCardAdd'})">添加银行卡</el-button>
      </div>
      <div class="instruction-li">
        <p class="instruction-li-title">银行卡管理说明：</p>
        <p style="line-height: 25px;"> 目前我司仅支持柜台换卡，如您因原银行卡遗失、消磁、其他等需申请换卡，请将以下资料发送至客服邮箱 khlh@myfp.cn：</p>
        <p style="line-height: 25px;"> 1、身份证正反面照片。</p>
        <p style="line-height: 25px;"> 2、新银行卡正反面照片。</p>
        <p style="line-height: 25px;">3、《展恒基金网上交易客户银行卡资料变更申请表》。<a class="aColor" href="https://trade.myfund.com/personal/file/BankChange.docx" target="_blank" download="BankChange.docx"> 点此下载 </a><a class="aColor" href="https://trade.myfund.com/personal/file/BankChangesimple.pdf" target="_blank" download="BankChangesimple.pdf">查看填写样例</a></p><br>
        <p style="line-height: 25px;">您所选支付银行卡有以下情形之一，将不能进行删除银行卡操作：</p>
        <p style="line-height: 25px;"> 1、有基金份额。</p>
        <p style="line-height: 25px;"> 2、距当前日期7个工作日内有在途交易（认购、申购、赎回、转换、定投协议等）。</p>
        <p style="line-height: 25px;"> 3、距当前日期7个工作日内有在途权益（赎回款、分红款等）。</p>
        <p style="line-height: 25px;"> 4、其他使得资金账户当前处于非正常状态的情形。</p>
        <p style="line-height: 25px;"> 删除的银行卡，您可自行在平台上重新绑定。</p>
      </div>
    </div>
    <!-- 删除银行卡 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable" :close-on-click-modal="false">
      <div class="dialog-single-three-p">请输入交易密码</div>
      <el-form :model="cancelForm" ref="cancelFormRef" class="margin-t20" style="position: relative;">
        <el-form-item label="活动名称" prop="name" style="display:none;">
          <el-input v-model="cancelForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input v-model="cancelForm.pass" type="password" autocomplete="new-password" @blur="passBlur" show-password></el-input>
          <span class="dialog-single-three-error" v-show="errorShow">{{errorMessage}}</span>
        </el-form-item>
      </el-form>
      <div class="margin-t35">
        <el-button type="cancel" style="width:154px" @click="cancel">取消</el-button>
        <el-button type="normal1" @click="deleteClick">{{deleteText}}</el-button>
      </div>
    </el-dialog>
    <!-- 更换渠道 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisableChange" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="dialog-single-three-p">支付渠道更换</div>
      <el-radio-group v-model="payType" class="radio-single-one margin-t20">
        <el-radio v-for="(item,i) in currentBank.channel" :key="i" :label="item.paycentername">
          {{item.paycentername}}支付{{item.ismain==1?'（已设为默认）':''}}
        </el-radio>
      </el-radio-group>
      <p class="margin-t5" v-for="(val,ind) in currentBank.channel" :key="ind">
        <span v-if="payType==val.paycentername">单笔{{val.singledeallimit}}元，单日累计{{val.singledaylimit}}元</span>
      </p>
      <div class="margin-t20">
        <el-button type="cancel" style="width:154px" @click="channelCancel">取消</el-button>
        <el-button type="normal1" @click="channelSure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      dialogVisable: false,
      dialogVisableChange: false,
      defaultRadio: true,
      bankCardTime: '--',//开通时间
      paycenterName:'--',
      bankLists: [],
      SingleDealLimit: '--',//单笔
      SingleDayLimit: '--',//单日
      // 删卡
      errorShow: false,
      errorMessage: '',
      cancelForm: {
        name: '',
        pass: ''
      },
      currentBank: {
        paycenterid:'',
        channelid:'',
        depositacct:'',
        moneyaccount:'',
        depositaccount:'',
        channel:[],
      },
      deleteText: '确定',
      // 支付路由
      payType: '汇付',
      newCannel:false,
      singledeallimit: '',
      singledaylimit: '',
    }
  },
  mounted () {
    this.getCardList()
  },
  methods: {
    // 银行卡列表
    getCardList () {
      this.bankLists = []
      this.$http.post(this.$apiPath.myBankList, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        // console.log(res);
        if(res.data.code == 200) {
          const bankList = res.data.data
          if (bankList.length > 0) {
            let item = bankList.find(item => {
              return item.flag == "1"
            });
            if (item == null) this.currentBank = bankList[0]
            bankList.forEach((item) => {
              if (item.flag == "1") {
                this.bankLists.unshift(item)
                this.currentBank = item
              } else {
                this.bankLists.push(item)
              }
            });
            this.defaultRadio = this.bankLists[0].flag == "1" ? true : false
            this.newCannel = this.bankLists[0].channelNot.length > 0 ? true : false
            this.bankLists[0].active = true
            // this.getBankInfo(this.bankLists[0].transactionaccountid)
            // 限额
            this.SingleDealLimit = this.bankLists[0].singledeallimit
            this.SingleDayLimit = this.bankLists[0].singledaylimit
            this.singledeallimit = this.bankLists[0].singledeallimit//-------------------------------
            this.singledaylimit = this.bankLists[0].singledaylimit
            this.paycenterName = this.bankLists[0].channel[0].paycentername
            this.payType = this.paycenterName
            this.bankCardTime = this.bankLists[0].modidate
          }
        }
      }).catch(err => { })
    },
    // 银行卡详情
    // getBankInfo (id) {
    //   this.$http.post(this.$apiPath.getbankinfo, {
    //     sessionId: this.$commonJs.getCookie('sessionid'),
    //     transactionaccountid: id
    //   }).then(res => {
    //     // console.log(res);
    //     if(res.data.code == 200) {
    //       const bankInfo = res.data.data.bankList[0]
    //       if (bankInfo) {
    //         this.bankCardStatus = '正常'
    //         this.bankCardTime = this.$commonJs.getDateStrHg(bankInfo.modidate)
    //       }
    //     }
    //   }).catch(err => { })
    // },
    clearActive (arr) {
      arr.forEach(item => {
        item.active = false
      })
    },
    // 切换银行卡
    bankImgClick (val, i) {
      this.currentBank = val
      this.clearActive(this.bankLists)
      val.active = true
      Vue.set(this.bankLists, i, val)
      this.defaultRadio = val.flag == "1" ? true : false
      this.newCannel = val.channelNot.length > 0 ? true : false
      this.bankCardTime = val.modidate
      // 限额
      this.SingleDealLimit = val.singledeallimit
      this.SingleDayLimit = val.singledaylimit
      this.singledeallimit = val.singledeallimit
      this.singledaylimit = val.singledaylimit
      this.paycenterName = val.channel[0].paycentername
      this.payType = this.paycenterName
    },
    // 迁移新支付渠道
    hfVerification () {
      if(this.newCannel) {
        this.$router.push({
          name: 'bankCardVerificationHf',
          params: {
            name: 'accountManagement',
            cardMessage: this.currentBank
          }
        })
      } else {
        this.$message.warning('暂无可签约渠道')
      }
    },
    // 默认卡
    defaultCard () {
      this.$http.post(this.$apiPath.updDdefault, {
        certificateno: Base64.decode(this.$commonJs.getCookie('u_id')),
        depositaccount: this.currentBank.depositaccount
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        this.getCardList()
      }).catch(err => { })
    },
    // 删除银行卡
    deleteClick () {
      var inputpwd = this.$des.enString(this.cancelForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
      var reallypass = this.$commonJs.getCookie('Password')
      if (inputpwd != reallypass) {
        this.errorShow = true
        this.errorMessage = "密码输入错误"
      } else {
        this.deleteText = '确定中...'
        this.errorShow = false
        this.$http.post(this.$apiPath.deleteBank, {
          sessionId: this.$commonJs.getCookie('sessionid'),
          paycenterid: this.currentBank.paycenterid,
          channelid: this.currentBank.channelid,
          depositacct: this.currentBank.depositacct,
          moneyaccount: this.currentBank.moneyaccount,
          certificatetype: '0',
          certificateno: Base64.decode(this.$commonJs.getCookie('u_id')),
          depositaccount: this.currentBank.depositaccount
        }).then(res => {
          if (res.status !== 200) return
          this.deleteText = '确定'
          if (res.data.code == 200) {
            this.$message.success('删除银行卡成功')
            this.dialogVisable = false
            this.$refs.cancelFormRef.resetFields();
            this.getCardList()
          } else {
            this.errorShow = true
            this.errorMessage = res.data.data.ret_msg
          }

        }).catch(err => { })
      }
    },
    passBlur () {
      if (this.cancelForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
      }
    },
    cancel () {
      this.dialogVisable = false
      this.$refs.cancelFormRef.resetFields();
      this.errorMessage = ''
    },
    // 取消渠道
    channelCancel() {
      this.dialogVisableChange = false
      this.payType = this.paycenterName
    },
    // 更换渠道
    channelSure() {
      let i = this.currentBank.channel.findIndex(item => item.paycentername == this.payType)
      this.$http.post(this.$apiPath.defaultChannel, {
        paycenterid: this.currentBank.channel[i].paycenterid,
        moneyaccount: this.currentBank.moneyaccount,// 一张卡一个moneyaccount
        channelid: this.currentBank.channel[i].channelid,
        sessionId: this.$commonJs.getCookie('sessionid'),
        deviceId: '',
        appnew: 1,
      }).then(res => {
        // console.log(res);
        if(res.data.code == 200) {
          this.$message.success('更换渠道成功')
        } else {
          this.$message.error('更换渠道失败')
        }
        this.dialogVisableChange = false
        this.getCardList()
      }).catch(err => {})
    }
  }
}
</script>

<style lang="less" scoped>
.bankManage {
  &-caption {
    height: 80px;
    line-height: 80px;
    font-size: 16px;
    color: @color6;
    border-bottom: 1px dashed #c9c9c9;
    span:nth-child(1) {
      margin-right: 20px;
    }
    span:nth-child(2) {
      margin-right: 180px;
    }
  }
  &-bankCard {
    overflow: hidden;
    margin: 20px 0;
    .card {
      position: relative;
      margin: 18px 0;
      width: 172px;
      height: 74px;
      box-sizing: border-box;
      position: relative;
      background: white;
      float: left;
      margin-right: 7px;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid #c9c9c9;
      img {
        margin-left: 10px;
        margin-top: 10px;
        width: 65%;
      }
      .num {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        text-align: center;
        line-height: 25px;
      }
      .tips {
        position: absolute;
        bottom: -23px;
        height: 22px;
        line-height: 22px;
        color: #e6a23c;
        font-size: 12px;
        cursor: text;
      }
    }
  }
  &-cardDetail {
    display: inline-block;
    width: 50%;
    padding-bottom: 20px;
    border-bottom: 1px dashed @colorC8;
    li {
      min-height: 35px;
      line-height: 35px;
      color: @color3;
      font-weight: bold;
      span {
        font-weight: normal;
        color: @color6;
      }
      p {
        margin-top: -5px;
        width: 920px;
        line-height: 25px;
        margin-left: 74px;
        color: #666;
        font-weight: 400;
      }
      .operate {
        color: @color;
        cursor: pointer;
      }
    }
  }
}
.activee {
  background: url(https://trade.myfund.com/kfit/img/new20200910/20201116_bankBack.png)
    no-repeat !important;
  background-size: 100% 100% !important;
}
.cardBox {
  padding: 50px;
  border-bottom: 1px dashed @colorC8;
  text-align: center;
}
</style>
